import { render } from "./Theme.vue?vue&type=template&id=7679eeb0"
import script from "./Theme.vue?vue&type=script&lang=ts"
export * from "./Theme.vue?vue&type=script&lang=ts"
script.render = render

export default script